export interface ResponseMetaDto {
  limit?: number;
  offset?: number;
  total?: number;
}

export interface ResponseDto<T> {
  statusCode?: number;
  message?: string;
  data?: T;
  meta?: ResponseMetaDto;
  error?: boolean;
}

export interface SimpleResponseDto {
  statusCode?: number;
  message?: string;
}
